<template>
    <div class="flex items-stretch justify-between space-x-4 font-gotham pb-3 pt-1">
        <TaskStatusList class="w-1/2 h-[225px]" :items="resultadosFiltrados"/>
        <ChartByProcess class="w-1/2 h-[225px]" :items="props.countTaskByProcess"/>
    </div>

    <!-- Filtros SIEMPRE visibles -->
    <div class="bg-white relative border rounded-lg font-gotham p-4">
        <div class="flex items-center justify-between">
            <div class="flex items-center space-x-4">
                <!-- Search bar -->
                <SearchForm @buscar="administrarBusqueda"/>
                <!-- Date Range Picker -->
                <DateRangePicker @update:dateRange="handleDateRangeChange" />
                <!-- Status Filter -->
                <StatusFilter @update:status="handleStatusChange" />
            </div>
                <div class="flex items-center justify-end text-sm font-semibold">
                
                <!-- Botón de recarga -->
                <button 
                @click="recargarPagina"
                class="inline-flex items-center px-2 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors duration-200 relative"
                title="Recargar datos"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                    <span v-if="amountOfTasks > props.items.length" class="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                        {{ amountOfTasks - props.items.length }}
                    </span>
                </button>
            </div>
        </div>
    </div>

    <!-- Si hay datos, muestra la tabla -->
    <div v-if="props.items.length > 0" class="bg-white relative border rounded-lg font-gotham">

        <table class="w-full text-sm text-left text-gray-500">
            <thead class="text-xs text-gray-700 uppercase bg-gray-200">
                <tr>
                    <th class="px-4 py-3"></th>
                    <th class="px-4 py-3">Ref. Base</th>
                    <th class="px-4 py-3">ID Trámite</th>
                    <th class="px-4 py-3">Trámite</th>
                    <th class="px-4 py-3">Fase</th>
                    <th class="px-4 py-3">Id Solicitante</th>
                    <th class="px-4 py-3">Solicitante</th>
                    <th class="px-4 py-3">Fecha llegada</th>
                    <th class="px-4 py-3">Fecha vencimiento</th>
                    <th class="px-4 py-3">Detalle</th>
                    <th class="px-4 py-3"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in paginatedItems" 
                    :key="`${item.taskId}-${currentPage}-${index}`" 
                    class="border-b" 
                    @click="abrirTareaNuevaPestanna(item.taskId ?? 0, item.project ?? 'VUI')"
                >
                    <td class="px-4 py-3">
                        <span v-if="comprobarVencimiento(item.deadline ?? new Date()) == 'vencida'" class="text-red-500 cursor-pointer" title="VENCIDA">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <circle cx="10" cy="10" r="8" />
                            </svg>
                        </span>
                        <span v-else-if="comprobarVencimiento(item.deadline ?? new Date()) == 'casi_vencida'" class="text-yellow-500 cursor-pointer" title="POR VENCER">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <circle cx="10" cy="10" r="8" />
                            </svg>
                        </span>
                        <span v-else-if="comprobarVencimiento(item.deadline ?? new Date()) == 'en_tiempo'" class="text-green-500 cursor-pointer" title="A TIEMPO">
                             <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <circle cx="10" cy="10" r="8" />
                            </svg>
                        </span>
                    </td>
                    <td class="px-4 py-3 font-medium text-gray-900">{{ item.processBaseReference }}</td>
                    <td class="px-4 py-3 font-medium text-gray-900">{{ item.processTheme1 }}</td>
                    <td class="px-4 py-3 font-medium text-gray-900">{{ item.processClassName }}</td>
                    <td class="px-4 py-3 font-medium text-gray-900">{{ item.processTheme2 }}</td>
                    <td class="px-4 py-3 font-medium text-gray-900">{{ item.processTheme3 }}</td>
                    <td class="px-4 py-3 font-medium text-gray-900">{{ item.processTheme4 }}</td>
                    <td class="px-4 py-3 font-medium text-gray-900">{{ formatFecha(item.arrivalDate ?? new Date()) }}</td>
                    <td class="px-4 py-3 font-medium text-gray-900">{{ formatFecha(item.deadline ?? new Date()) }}</td>
                    <td class="px-4 py-3 font-medium text-gray-900">
                        {{ item.processTheme5 }}
                    </td>
                    <td class="px-4 py-3 w-10">
                        <button 
                            @click.stop="mostrarDetalle(item)"
                            class="text-gray-500 hover:text-gray-700"
                            title="Ver detalles"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        
        <!-- Paginación -->
        <div class="flex items-center justify-between p-4 border-t">
            <div class="text-sm text-gray-600">
                Mostrando {{ startIndex + 1 }} - {{ endIndex }} de {{ resultadosFiltrados.length }} resultados
            </div>
            <div class="flex space-x-2">
                <button 
                    @click="currentPage--"
                    :disabled="currentPage === 1"
                    class="px-3 py-1 border rounded hover:bg-gray-100 disabled:opacity-50"
                    title="Anterior"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                    </svg>
                </button>
                <button 
                    @click="currentPage++"
                    :disabled="currentPage >= totalPages"
                    class="px-3 py-1 border rounded hover:bg-gray-100 disabled:opacity-50"
                    title="Siguiente"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                    </svg>
                </button>
            </div>
        </div>
    </div>

        <!-- Seccion Animacion Recargar -->
        <div v-if="props.loading" class="bg-white relative border rounded-lg font-gotham p-12">
        <div class="text-center space-y-6">
            <div class="flex justify-center">
                <svg class="w-24 h-24 animate-spin" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none"/>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                        <animateTransform
                            attributeName="transform"
                            attributeType="XML"
                            type="rotate"
                            from="0 12 12"
                            to="360 12 12"
                            dur="1s"
                            repeatCount="indefinite"/>
                    </path>
                </svg>
            </div>
            <h2 class="text-3xl font-bold text-gray-800">Cargando tareas...</h2>
            <div class="h-2 w-60 mx-auto bg-gray-200 rounded-full overflow-hidden">
                <div class="h-full bg-gradient-to-r from-[#45a4c9] to-[#6baa19] animate-pulse"></div>
            </div>
        </div>
    </div> 

    <!-- Si no hay datos, muestra el mensaje "¡Estás al día!" -->
    <div v-else-if="props.items.length === 0" class="bg-white relative border rounded-lg font-gotham p-12">
        <div class="text-center space-y-6">
            <div class="flex justify-center">
                <svg class="w-24 h-24 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
            </div>
            <h2 class="text-3xl font-bold text-gray-800">¡Estás al día!</h2>
            <p class="text-xl text-gray-600">No tienes tareas asignadas en este momento</p>
        </div>
    </div>

    <!-- Si Existe Error Sale Mensaje de Error. -->
    <div v-else-if="props.hasError" class="bg-white relative border rounded-lg font-gotham p-12">
        <div class="text-center space-y-6">
            <div class="flex justify-center">
                <svg class="w-24 h-24 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M21 20H3l9-16 9 16z"></path>
                </svg>
            </div>
            <h2 class="text-3xl font-bold text-gray-800">¡Ha Ocurrido un Error!</h2>
            <p class="text-xl text-gray-600">Favor contactar a soporte</p>
        </div>
    </div>

    <TaskDetail 
        v-if="showOverlay" 
        :task="selectedItem!"
        @close="showOverlay = false"
        :userData="props.userdata"
    />
</template>

<script setup lang="ts">
import { defineProps, computed, ref, defineEmits, /**onMounted, onUnmounted,**/ watch } from 'vue';
import ITask from '@/interfaces/ITask'
import ICountTaskByProcess from '@/interfaces/ICountTaskByProcess'
import SearchForm from './SearchForm.vue';
import config from '@/config/config';
import DateRangePicker from './DateRangePicker.vue';
import StatusFilter from './StatusFilter.vue';
import TaskStatusList from './TaskStatusList.vue';
import ChartByProcess from './ChartByProcess.vue';
import ApiService from '@/services/ApiService'
import TaskDetail from './TaskDetail.vue';

const service = new ApiService()
const filtro = ref('');
const radioFilter = ref('');
const filtroEstados = ref<string[]>([]);
const statusFilter = ref('Pending');
const amountOfTasks = ref<number>(0);

const props = defineProps({
    items: {
        type: Array as () => Array<ITask>,
        required: true
    },
    countTaskByProcess: {
        type: Array as () => Array<ICountTaskByProcess>,
        required: true
    },
    userdata: {
        type: String,
        required: true
    },
    loading: {
        type: Boolean,
        required: true
    },
    hasError: {
        type: Boolean,
        required: true,
    }
})

interface DateRange {
    startDate: Date | null;
    endDate: Date | null;
}

const dateRange = ref<DateRange>({
    startDate: null,
    endDate: null
});

const resultadosFiltrados = computed(() => {
    let items = props.items;

    switch (radioFilter.value) {
        case 'VUI':
            items = items.filter(item => item.project && item.project.toLowerCase().includes('vui'))
            break;
        case 'SISTEMAS':
            items = items.filter(item => item.project && item.project.toLowerCase().includes('sistemas'))
            break;
        default:
            break;
    }

    if (dateRange.value.startDate && dateRange.value.endDate) {
        items = items.filter(item => {
            const itemDate = new Date(item.arrivalDate ?? new Date());
            const endDate = new Date(dateRange.value.endDate!);
            endDate.setHours(23, 59, 59, 999);
            
            return itemDate >= dateRange.value.startDate! && 
                   itemDate <= endDate;
        });
    }

    if (filtroEstados.value.length === 1 && filtroEstados.value[0] !== 'Vencidas') {
        items = items.filter(item => item.statusName && (filtroEstados.value.includes(item.statusName) || filtroEstados.value.length === 0));
    }

    if (filtroEstados.value.includes('Vencidas')) {
        items = items.filter(item => comprobarVencimiento(item.deadline ?? new Date()));
    }

    if (filtro.value !== '') {
        items = items.filter(item => 
            item.processClassName && item.processClassName.toLowerCase().includes(filtro.value.toLowerCase()) || 
            item.processBaseReference && item.processBaseReference.toLowerCase().includes(filtro.value.toLowerCase()) || 
            item.processTheme1 && item.processTheme1.toLocaleLowerCase().includes(filtro.value.toLocaleLowerCase()) || 
            item.processTheme2 && item.processTheme2.toLocaleLowerCase().includes(filtro.value.toLocaleLowerCase()) || 
            item.processTheme3 && item.processTheme3.toLocaleLowerCase().includes(filtro.value.toLocaleLowerCase()) || 
            item.processTheme4 && item.processTheme4.toLocaleLowerCase().includes(filtro.value.toLocaleLowerCase()) || 
            item.processTheme5 && item.processTheme5.toLocaleLowerCase().includes(filtro.value.toLocaleLowerCase()) || 
            item.project && item.project.toLocaleLowerCase().includes(filtro.value.toLocaleLowerCase()))
    }

    return items;
})

const handleDateRangeChange = (newDateRange: DateRange) => {
    dateRange.value = newDateRange;
};

const administrarBusqueda = (value: string) => 
{
    filtro.value = value;
}

const abrirTareaNuevaPestanna = (taskId: number, origen: string) => {
    const url = origen === 'VUI' 
        ? `${config.urls.vuiTaskUrl}?id=${taskId}&userdata=${props.userdata}` 
        : `${config.urls.sistemasTaskUrl}?id=${taskId}&userdata=${props.userdata}`;

    window.open(url, '_blank');
}

const formatFecha = (date: Date) => {
    const fecha = new Date(date);
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const anio = fecha.getFullYear();
    // if fecha  is 1/1/1900 return empty string
    return dia === 1 && mes === 1 && anio === 1900 ? "" : `${dia}/${mes}/${anio}`;
}

const comprobarVencimiento = (date: Date) => {
    const fecha = new Date(date);
    const hoy = new Date();
    const casiVencida = new Date(fecha);
    casiVencida.setDate(casiVencida.getDate() - 1);

    if (fecha.getDate() === 1 && fecha.getMonth() === 0 && fecha.getFullYear() === 1900){
        return "en_tiempo";
    }

    if (fecha < hoy){
        return "vencida";
    } else if (casiVencida <= hoy){
        return "casi_vencida";
    } else {
        return "en_tiempo";
    }
}

const emit = defineEmits<{
    'update:status': [status: string]
}>()

const handleStatusChange = (newStatus: string) => {
    statusFilter.value = newStatus;
    emit('update:status', newStatus);
};

const recargarPagina = () => {
    window.location.reload();
}

/* No se sabe porqué está comentado.  */
/** 
let intervalId: number;

onMounted(async () => {
    intervalId = setInterval(async () => {
        await service.setAmountOfTasks(props.userdata, statusFilter.value);
        amountOfTasks.value = await service.getAmountOfTasks().value;
    }, 60000);
});

onUnmounted(() => {
    clearInterval(intervalId);
});
**/

const showOverlay = ref(false);
const selectedItem = ref<ITask | null>(null);

const mostrarDetalle = (item: ITask) => {
    selectedItem.value = item;
    showOverlay.value = true;
}

const currentPage = ref(1);
const itemsPerPage = 10;

const totalPages = computed(() => {
    return Math.ceil(resultadosFiltrados.value.length / itemsPerPage);
});

const startIndex = computed(() => (currentPage.value - 1) * itemsPerPage);

const endIndex = computed(() => {
    return Math.min(startIndex.value + itemsPerPage, resultadosFiltrados.value.length);
});

const paginatedItems = computed(() => {
    const items = resultadosFiltrados.value;
    const start = (currentPage.value - 1) * itemsPerPage;
    const end = Math.min(start + itemsPerPage, items.length);
    
    const slicedItems = items.slice(start, end);
    
    return slicedItems;
});

watch([() => resultadosFiltrados.value.length], () => {
    const maxPage = Math.max(1, totalPages.value);
    if (currentPage.value > maxPage) {
        currentPage.value = maxPage;
    }
});

watch([filtro, radioFilter, filtroEstados, dateRange], () => {
    currentPage.value = 1;
});
</script>

<style scoped>
.animate-spin {
    background: linear-gradient(90deg, #45a4c9 0%, #6baa19 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

tr {
    cursor: pointer;
}

button {
    cursor: pointer;
}

tr:hover {
    background-color: rgb(229, 231, 235);
}

.flex > * + * {
    margin-left: 1rem;
}

button:disabled {
    cursor: not-allowed;
}
</style>